import { PencilEdit, SamJackson } from "../assets/img";

export default function ProfileSettings() {
  return (
    <>
      <div className="flex-1 min-h-[576px] rounded-lg border border-[#BFBFBF] bg-white p-8 shadow-custom3">
        <div className="flex flex-col items-center mx-auto h-[182px] w-[213px] border rounded-[7px] border-secondary/30 shadow-custom4 p-3">
          <img
            src={SamJackson}
            alt="profile"
            className="relative mb-3 h-[70px] w-[70px] overflow-hidden rounded-full object-cover object-top"
          />
          <h3 className="text-base font-semibold">Sam Jackson</h3>
          <p className="flex items-center gap-1 text-sm text-secondary">
            Samjack12
            <PencilEdit className="ml-2 cursor-pointer" />
          </p>
        </div>

        <form className="mt-8 grid grid-cols-2 gap-x-4 gap-y-6 md:gap-x-6">
          <div>
            <label className="mb-1 block text-xs xs:text-sm md:text-base font-semibold text-secondary">
              First Name
            </label>
            <input
              type="text"
              defaultValue="Sam"
              className="w-full rounded-md border border-secondary/40 px-3 py-2 text-sm shadow-sm focus:border-black focus:outline-none"
            />
          </div>
          <div>
            <label className="mb-1 block text-xs xs:text-sm md:text-base font-semibold text-secondary">
              Last Name
            </label>
            <input
              type="text"
              defaultValue="Jackson"
              className="w-full rounded-md border border-secondary/40 px-3 py-2 text-sm shadow-sm focus:border-black focus:outline-none"
            />
          </div>
          <div>
            <label className="mb-1 block text-xs xs:text-sm md:text-base font-semibold text-secondary">
              Email
            </label>
            <input
              type="email"
              defaultValue="s.jackson12@gmail.com"
              className="w-full rounded-md border border-secondary/40 px-3 py-2 text-sm shadow-sm focus:border-black focus:outline-none"
            />
          </div>
          <div>
            <div className="flex items-center justify-between">
              <label className="mb-1 block text-xs xs:text-sm md:text-base font-semibold text-secondary">
                Password
              </label>
              <button
                type="button"
                className="text-[10px] xs:text-xs md:text-sm font-medium text-primary"
              >
                Change
              </button>
            </div>
            <input
              type="password"
              defaultValue="********"
              className="w-full rounded-md border border-secondary/40 px-3 py-2 text-sm shadow-sm focus:border-black focus:outline-none"
              readOnly
            />
          </div>
          <div className="col-span-2 flex justify-center">
            <button
              type="submit"
              className="max-w-[215px] w-full rounded bg-secondary px-10 py-2 text-sm font-medium text-white hover:bg-gray-800"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
